// Page « Guide des tailles » ouverte depuis le panneau rapide d'une carte (lien ?paire=<handle>, snippets/snk-quick-add) :
// barre « Continuer avec cette paire » avec la photo et le nom de la paire, qui ramène sur sa fiche (LG, 4 nov. 2026).
// Sans paramètre, ou paire introuvable : rien ne s'affiche.
if (!customElements.get('snk-guide-return')) {
  customElements.define(
    'snk-guide-return',
    class SnkGuideReturn extends HTMLElement {
      async connectedCallback() {
        const handle = new URLSearchParams(window.location.search).get('paire');
        if (!handle || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) return;
        const root = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(`${root}products/${handle}.js`);
          if (!response.ok) return;
          const product = await response.json();
          this.querySelector('[data-snk-gr-link]').href = `${root}products/${handle}`;
          this.querySelector('[data-snk-gr-title]').textContent = product.title;
          const img = this.querySelector('[data-snk-gr-img]');
          if (product.featured_image) {
            const src = product.featured_image.startsWith('//') ? `https:${product.featured_image}` : product.featured_image;
            img.src = `${src}${src.includes('?') ? '&' : '?'}width=160`;
          } else {
            img.remove();
          }
          this.hidden = false;
        } catch (error) {
          // Pas de barre : la page du guide reste utilisable telle quelle
        }
      }
    }
  );
}
